import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormText, FormGroup, FormBuilder } from "@coso/forms";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { GroupStorage, MappingMode } from "../../../../../models/auto-generated";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Validators } from "@angular/forms";

export interface UserMappingSettings {
  mappingMode: MappingMode;
  autoRefresh: boolean;
  refreshInterval: number;
}

@Component({
  standalone:false,
  templateUrl: "./user-mapping-settings.component.html"
})
export class UserMappingSettingsComponent implements OnInit, OnDestroy {
  private unsubscribe = new Subject<void>();
  MappingMode = MappingMode;
  GroupStorage = GroupStorage;

  formGroup: FormGroup<UserMappingSettings>;
  formText: FormText<UserMappingSettings>;

  errorMessage: string;
  isReadOnly: boolean;
  currentSettings: UserMappingSettings;
  groupStorage: GroupStorage;
  saveCallback: (newValue: UserMappingSettings) => void;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) {}

  ngOnDestroy(): void {
    this.unsubscribe.next();
  }

  ngOnInit(): void {
    this.formGroup = this.fb.group<UserMappingSettings>({
      mappingMode: this.fb.control(MappingMode.APPEND, [Validators.required]),
      autoRefresh: this.fb.control(true),
      refreshInterval: this.fb.control(180)
    });
    this.formText = {
      autoRefresh: {
        label: "Auto-refresh",
        labelClass: "col-lg-4",
        inputContainerClass: "col-lg-6",
        popover: "Automatically reload (refresh) the user mapping at a set interval.",
        enable: "Yes",
        disable: "No"
      },
      refreshInterval: {
        label: "Refresh interval",
        labelClass: "col-lg-4",
        inputContainerClass: "col-lg-6",
        popover: "The interval of time (in seconds) between checks for users to be automatically mapped.",
        errors: {
          required: "The Refresh interval field is required.",
          min: "The Refresh interval field must be greater than or equal to 1.",
          max: "The Refresh interval field must be less than or equal to 3600.",
          pattern: "The Refresh interval field must contain only numbers."
        }
      }
    };
    this.formGroup.controls["autoRefresh"].valueChanges.pipe(takeUntil(this.unsubscribe)).subscribe((value) => {
      if (value) {
        this.formGroup.controls["refreshInterval"].setValidators([Validators.required, Validators.min(1), Validators.max(3600), Validators.pattern(/^[0-9]*$/)]);
        this.formGroup.controls["refreshInterval"].markAsUntouched();
        this.formGroup.controls["refreshInterval"].markAsPristine();
        this.formGroup.controls["refreshInterval"].updateValueAndValidity();
      } else {
        this.formGroup.controls["refreshInterval"].clearValidators();
        this.formGroup.controls["refreshInterval"].updateValueAndValidity();
      }
    });

    this.formGroup.patchValue(this.currentSettings);
    this.formGroup.updateValueAndValidity();
  }

  save() {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
    } else {
      this.saveCallback(this.formGroup.getRawValue());
    }
  }
}
